/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_preconfigureUser_user_preconfigureUser_post } from '../models/Body_preconfigureUser_user_preconfigureUser_post';
import type { NewRegistration } from '../models/NewRegistration';
import type { newUser_return } from '../models/newUser_return';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * Get current User information
     * @returns newUser_return Successful Response
     * @throws ApiError
     */
    public static readUsersMeUserMeGet(): CancelablePromise<newUser_return> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/me/',
        });
    }

    /**
     * Get current User ID from session
     * Get the current user's ID from the SuperTokens session.
     * This endpoint returns just the user ID for use in push notifications and other features.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getCurrentUserIdUserMeUserIdGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/me/user_id',
        });
    }

    /**
     * Change Password for current User
     * @param oldPassword
     * @param newPassword
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static changeUsersPasswordUserMeChangePwPost(
        oldPassword: string,
        newPassword: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/me/changePW',
            query: {
                'oldPassword': oldPassword,
                'newPassword': newPassword,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Change Email for current User
     * @param newEmail
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static changeUsersEmailUserMeChangeEmailPost(
        newEmail: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/me/changeEmail',
            query: {
                'newEmail': newEmail,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get all Usergroups - Admins only
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listUserGroupsUserGroupsGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/groups',
        });
    }

    /**
     * List of all Users - Admins only
     * @param showPreConfiguredUsers
     * @returns newUser_return Successful Response
     * @throws ApiError
     */
    public static listUsersUserListGet(
        showPreConfiguredUsers: boolean = false,
    ): CancelablePromise<Array<newUser_return>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/list',
            query: {
                'showPreConfiguredUsers': showPreConfiguredUsers,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List of all Users with Metadata - Admins only
     * @param onlyKunden
     * @param showPreConfiguredUsers
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listUsersWithMetadataUserListWithMetadataGet(
        onlyKunden: boolean = false,
        showPreConfiguredUsers: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/listWithMetadata',
            query: {
                'onlyKunden': onlyKunden,
                'showPreConfiguredUsers': showPreConfiguredUsers,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create new User - Admins only
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createUserUserCreatePost(
        requestBody: NewRegistration,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Preconfigure User - Admins only - out of order at the moment
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static preconfigureUserUserPreconfigureUserPost(
        requestBody: Body_preconfigureUser_user_preconfigureUser_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/preconfigureUser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add new Usergroup - Admins only
     * @param groupname
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static addNewUsergroupUserAddNewUsergroupPost(
        groupname: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/addNewUsergroup',
            query: {
                'groupname': groupname,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add User to Usergroup - Admins only
     * @param username
     * @param usergroup
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static addUserToUsergroupUserAddToUsergroupPost(
        username: string,
        usergroup: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/addToUsergroup',
            query: {
                'username': username,
                'usergroup': usergroup,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove User from Usergroup - Admins only
     * @param username
     * @param usergroup
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static removeUserFromUsergroupUserRemoveFromUsergroupDelete(
        username: string,
        usergroup: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/removeFromUsergroup',
            query: {
                'username': username,
                'usergroup': usergroup,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete User - Admins only
     * @param email
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteUserByNameUserDeleteDelete(
        email: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/delete',
            query: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reset Notifications
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static resetNotificationsUserResetNotificationsPost(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/resetNotifications',
        });
    }

    /**
     * Add Additional User Data - Admins only
     * @param userId
     * @param key
     * @param value
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static addAdditionalUserDataUserAddAdditionalUserDataPost(
        userId: string,
        key: string,
        value: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/addAdditionalUserData',
            query: {
                'user_id': userId,
                'key': key,
                'value': value,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List all Users with Additional Data
     * @returns any Successful Response
     * @throws ApiError
     */
    public static addAdditionalUserDataListUserAddAdditionalUserDataListGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/addAdditionalUserDataList',
        });
    }

    /**
     * Get Additional Data for current User
     * @returns any Successful Response
     * @throws ApiError
     */
    public static meAdditionalUserDataUserMeAdditionalUserDataGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/me/AdditionalUserData',
        });
    }

    /**
     * Set employee number for a user - Admins only
     * Set employee number for a user.
     * @param userId
     * @param employeeNumber
     * @returns any Successful Response
     * @throws ApiError
     */
    public static setEmployeeNumberUserSetEmployeeNumberPost(
        userId: string,
        employeeNumber: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/set_employee_number',
            query: {
                'user_id': userId,
                'employee_number': employeeNumber,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get employee number for current user
     * Get employee number for the current user.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getUserEmployeeNumberUserGetEmployeeNumberGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_employee_number',
        });
    }

    /**
     * Get employee number for a specific user - Admins only
     * Get employee number for a specific user.
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getEmployeeNumberForUserUserGetUserEmployeeNumberUserIdGet(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_user_employee_number/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get employee numbers for all users - Admins only
     * Get employee numbers for all users.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAllEmployeeNumbersUserGetAllEmployeeNumbersGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_all_employee_numbers',
        });
    }

    /**
     * Set vacation days for a user - Admins only
     * Set vacation days for a user.
     * @param userId
     * @param totalDays
     * @param remainingDays
     * @param pendingDays
     * @param initialRemainingDays
     * @param monthlyVacationDays
     * @returns any Successful Response
     * @throws ApiError
     */
    public static setVacationDaysUserSetVacationDaysPost(
        userId: string,
        totalDays: number,
        remainingDays?: number,
        pendingDays?: number,
        initialRemainingDays?: number,
        monthlyVacationDays?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/set_vacation_days',
            query: {
                'user_id': userId,
                'total_days': totalDays,
                'remaining_days': remainingDays,
                'pending_days': pendingDays,
                'initial_remaining_days': initialRemainingDays,
                'monthly_vacation_days': monthlyVacationDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Urlaubsstand eines Benutzers abrufen
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getVacationDaysUserGetVacationDaysGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_vacation_days',
        });
    }

    /**
     * Get vacation days for all users - Admins only
     * Get vacation days for all users.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAllVacationDaysUserGetAllVacationDaysGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_all_vacation_days',
        });
    }

    /**
     * Update remaining vacation days - Admins only
     * Subtract used vacation days from remaining days.
     * @param userId
     * @param daysUsed
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateRemainingVacationDaysUserUpdateRemainingVacationDaysPost(
        userId: string,
        daysUsed: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/update_remaining_vacation_days',
            query: {
                'user_id': userId,
                'days_used': daysUsed,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Request to use vacation days
     * Current user requests to use vacation days.
     * @param daysRequested
     * @returns any Successful Response
     * @throws ApiError
     */
    public static requestVacationUserMeRequestVacationPost(
        daysRequested: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/me/request_vacation',
            query: {
                'days_requested': daysRequested,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Approve vacation request - Admins only
     * Admin approves a vacation request and deducts days.
     * @param requestId
     * @param userId
     * @param daysApproved
     * @returns any Successful Response
     * @throws ApiError
     */
    public static approveVacationUserAdminApproveVacationPost(
        requestId: string,
        userId: string,
        daysApproved: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/admin/approve_vacation',
            query: {
                'request_id': requestId,
                'user_id': userId,
                'days_approved': daysApproved,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Initialen Urlaubsstand setzen - Nur für Admins
     * Setzt den initialen Urlaubsstand für einen Benutzer.
     * Dieser Wert dient als Basis für alle Berechnungen der verbleibenden Urlaubstage.
     * @param userId
     * @param initialDays
     * @returns any Successful Response
     * @throws ApiError
     */
    public static setInitialVacationDaysUserSetInitialVacationDaysPost(
        userId: string,
        initialDays: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/set_initial_vacation_days',
            query: {
                'user_id': userId,
                'initial_days': initialDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
